import { externalUploadPoller } from '@ff-os/pdp-shared-redux/apis/external-upload/externalUploaderPoller';
import { PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';
import { createExternalUploadPollListener } from '../thunks/photoPrintsPollHandler';
import { prepareUiState } from './prepareUiState';
import { startBlobStoreGarbageCollector } from './startBlobUrlGarbageCollector';
import { subscribe } from './subscriptions';

export const startup = async (store: PhotoPrintsPdpStore) => {
    subscribe(store);
    externalUploadPoller.addPollListener(createExternalUploadPollListener(store));
    startBlobStoreGarbageCollector(store);
    prepareUiState(store.dispatch, store.getState);
};